import type {Ref} from "vue";
import type {JsonApiResponse} from "~/types/JsonApiResponse";
import type {UserData} from "~/types/UserData";
import type {CommentData} from "~/types/CommentData";
import type {BookmarkData} from "~/types/BookmarkData";

export const useReader = () => {
    const getReader = (userUuid: string) => {
        return useAsyncData<JsonApiResponse<UserData>>(`reader:${userUuid}`, () => $api(`/api/reader/${userUuid}`))
    }

    const getBookmarks = (userUuid: string, page: Ref<number>) => {
        return useAsyncData<JsonApiResponse<BookmarkData[]>>(`reader:${userUuid}:bookmarks`, () => $api(`/api/reader/${userUuid}/bookmarks`, {
            query: {
                page: page.value
            },
        }), {
            watch: [page]
        })
    }

    const getComments = (userUuid: string, page: Ref<number>) => {
        return useAsyncData<JsonApiResponse<CommentData[]>>(`reader:${userUuid}:comments`, () => $api(`/api/reader/${userUuid}/comments`, {
            query: {
                page: page.value
            },
        }), {
            watch: [page]
        })
    }

    return {
        getReader,
        getBookmarks,
        getComments
    }
}
